/**
 * @module builder
 */
import type { QuoteDocument, OptionsDocument } from 'paintscout'

import type { QuoteItemSection, UpdateableItem } from '../../index'

import { getArea } from '../../areas'
import { getLineItem } from '../../line-items'
import { getSubstrate } from '../../substrates'
import { getGroup } from '../../groups'

export function findItem(args: {
  quote: QuoteDocument
  options: OptionsDocument
  key: string
  section?: QuoteItemSection
}): UpdateableItem {
  const { quote, key } = args
  if (quote.areas[key]) {
    return getArea({ ...args, key })
  } else if (quote.lineItems[key]) {
    return getLineItem({ ...args, key })
  } else if (quote.substrates[key]) {
    return getSubstrate({ ...args, key })
  } else if (quote.groups[key]) {
    return getGroup({ ...args, key })
  }
  return null
}
